export interface CheckoutEmail {
  preferred: boolean;
  usage: string;
  value: string;
}
